import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import { Pagination } from 'src/reusable/global';
import Helper from 'src/support/Helper';
import HomePage from '@system/config/home-page';
import CommonContent from '../CommonContent';
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import NoResultContent from '../NoResultContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/support/Constants';
import ContentTabCommonSorting from "src/pages/HomePageContent/ContentTabs/ContentTabCommonSorting";

let c = System.getParams();

const AllContentTab = () => {
    const [list, setList] = useState([]);
    const [videoList, setVideoList] = useState([]);
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [{ allTabsCount }, { get_home_page_content }] = useHomePageContentStore();
    const [searchParams] = useSearchParams();
    const [HomePageContentTabList__Component__Loader, Set_HomePageContentTabList__Component__Loader] = useReduxState(
        searchParams.get(CommonContent.param_key_HomePageContentTabList) || CommonContent.default_component.param_value,
        CommonContent.redux_key_HomePageContentTabList
    );
    const [__check] = useAxiosIndicatorCheck();
    const { homePageAllTabs } = Constants;
    const [listObj, setListObj] = useState({ pageCount: 0, page: 1, limit: 20, sortBy: 'Relevance' });

    useEffect(() => {
        const fetchList = async () => {
            await fetchAPiCall(firstServerCall);
            if (firstServerCall) setFirstServerCall(false);
        };
        fetchList();
    }, [listObj.page, listObj.limit, listObj.sortBy, allTabsCount]);

    const fetchAPiCall = async (defaultStart = false) => {
        __set("CONTENT_API_CALL");
        const search_keyword = searchParams.get('search') || '';

        const contentData = await get_home_page_content({
            pageNumber: defaultStart ? 1 : listObj.page,
            pageSize: listObj.limit,
            sort: listObj.sortBy,
            searchTerm: search_keyword,
            contentType: homePageAllTabs.ALLCONTENT.contentType
        });

        let totalCount = 0;

        const allContentCount = contentData[homePageAllTabs.ALLCONTENT.contentType]?.totalCount || 0;
        const videoCount = allTabsCount?.contentTabCount?.video || 0;

        totalCount = listObj.page === 1 && allContentCount !== videoCount
            ? allContentCount - videoCount
            : allContentCount;

        const webContent = contentData[homePageAllTabs.ALLCONTENT.contentType]?.webContentView || [];

        if (totalCount > 0 && Array.isArray(webContent)) {
            const totalPages = Math.ceil(totalCount / listObj.limit);
            setListObj(prev => ({ ...prev, pageCount: totalPages }));

            setList(webContent.filter(v => v?.avnPageType !== homePageAllTabs.VIDEO.pageType));
            setVideoList(webContent.filter(v => v?.avnPageType === homePageAllTabs.VIDEO.pageType));
        } else {
            setList([]);
            setVideoList([]);
            setListObj(prev => ({ ...prev, pageCount: 0 }));
        }

        __remove("CONTENT_API_CALL");
    };

    const handlePageClick = (data) => {
        setListObj(prev => ({ ...prev, page: data.selected + 1 }));
        Helper.scrollTop();
    };

    const setPageLimit = (event) => {
        setListObj(prev => ({ ...prev, limit: Number(event.target.value), page: 1 }));
    };

    const onFilter = (e) => {
        setListObj(prev => ({ ...prev, page: 1, sortBy: e.target.value }));
    };

    const getTabLink = (singleElement) => {
        return HomePage.getHomeContentTabsListRouteURL({
            ...c,
            [CommonContent.param_key_HomePageContentTabList]: singleElement.param_value
        });
    };

    const switchTab = (url, chain_single) => {
        history.pushState('', '', url);
        Set_HomePageContentTabList__Component__Loader(chain_single.param_value);
    };

    const videoTabRedirection = () => {
        Helper.scrollTop();
        switchTab(getTabLink(CommonContent.chain_HomePageContentTabList.VDO), CommonContent.chain_HomePageContentTabList.VDO);
    };
    const ContentItem = ({ item }) => {
        return (
            <div className="all-content-body-item">
                <div className="bs5 row mx-0">
                    <div className="col-lg-9 col-md-12 ps-0 mb-3 mb-lg-0">
                        {item?.avnPageType !== homePageAllTabs.VIDEO.pageType && (
                            <div className="font-16 text-blue2 font-bold mb-1">
                                <span><a href={item?.url} target="_blank" rel="noopener noreferrer">{item.name}</a></span>
                                <span className="content-tag">{item.avnPageType}</span>
                            </div>
                        )}
                        {item?.avnPageType?.toLowerCase() === homePageAllTabs.ARTICLE.contentType && (
                            <div>{Helper.getLongDateFormat(item.avnDate)}</div>
                        )}
                        {item?.avnPageType !== homePageAllTabs.VIDEO.pageType && (
                            <>
                                <div className="ellipses mb-1" title={item.shortDescription}>{item.shortDescription}</div>
                                {item.shortDescription?.length > 140 && (
                                    <a href={item?.url} className="text-blue2 d-block" target="_blank" rel="noopener noreferrer">Read More</a>
                                )}
                            </>
                        )}
                    </div>
                    {item?.avnPageType?.toLowerCase() === homePageAllTabs.ARTICLE.contentType && item?.avnImage && (
                        <div className="col-lg-3 col-md-12 ps-0 text-start text-lg-end">
                            <div className="new-content-img">
                                <img className="img-fluid articleimage" src={item.avnImage} alt={item.name} />
                            </div>
                        </div>
                    )}
                    {item?.avnPageType?.toLowerCase() === homePageAllTabs.EVENT.contentType && (
                        <div className="date-location-box mt-2">
                            <div className="date-location-item"><b>Date:&nbsp;</b>{Helper.getLongDateFormat(item?.avnDate)}</div>
                            <div className="date-location-item"><b>Location:&nbsp;</b>{item.avnLocation}</div>
                        </div>
                    )}
                </div>
                <hr />
            </div>
        );
    };

    // Helper component to render video list items
    const renderVideoList = (videos) => (
        videos.slice(0, 4).map((video, idx) => (
            <div key={idx} className="col-auto px-0 mb-3 mb-lg-0">
                <div className="video-block">
                    <div className="video-iframe">
                        <iframe
                            src={video.url}
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            allowFullScreen
                            title={video.name}
                            width={200}
                        />
                    </div>
                    <a href={video.url} target="_blank" rel="noopener noreferrer" className="text-blue2 font-bold d-block mt-1 text-center">{video.name}</a>
                    <div className="mb-1" title={video.longDescription}>{video.longDescription}</div>
                </div>
            </div>
        ))
    );

    return (
        <div id="contentTypeAllContent" className="tab-pane fade in active">
            <div className="new-content-wrapper">
                <div className="bs5 row">
                    <div className="col-lg-9 tab-data">
                        <div className="all-content">
                            <ContentTabCommonSorting onFilter={onFilter} headerNme={homePageAllTabs.ALLCONTENT.tabHeader} dataLength={list.length} />
                            <hr />
                            <div className="position-relative">
                                <div>{__check(['CONTENT_API_CALL'], { overlay: true }).render}</div>
                                <div className="all-content-body">

                                    {/* No results if both empty */}
                                    {list.length === 0 && videoList.length === 0 && firstServerCall === false && (
                                        <NoResultContent message={`No Results Found for <b>"${searchParams.get('search')}"</b>`} />
                                    )}

                                    {/* Video list only if list empty */}
                                    {list.length === 0 && videoList.length > 0 && (
                                        <>
                                            <div className="all-content-body-item">
                                                <div className="bs5 row mx-0">
                                                    {renderVideoList(videoList)}
                                                </div>
                                            </div>
                                            {videoList.length >= 4 && (
                                                <div className="mt-4">
                                                    <button className="bs5 btn btn-secondary w200" onClick={videoTabRedirection}>
                                                        See All Videos
                                                    </button>
                                                </div>
                                            )}
                                            <hr />
                                        </>
                                    )}

                                    {/* Show list with videos inserted after 2 items */}
                                    {list.length > 0 && videoList.length > 0 && (
                                        <>
                                            {/* First 2 list items */}
                                            {list.slice(0, 2).map((v, i) => (
                                                <ContentItem key={`list-start-${i}`} item={v} />
                                            ))}

                                            {/* Video items inserted here */}
                                            <div className="all-content-body-item">
                                                <div className="bs5 row mx-0">
                                                    {renderVideoList(videoList)}
                                                </div>
                                                {videoList.length >= 4 && (
                                                    <div className="mt-4">
                                                        <button className="bs5 btn btn-secondary w200" onClick={videoTabRedirection}>
                                                            See All Videos
                                                        </button>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Remaining list items */}
                                            {list.slice(2).map((v, i) => (
                                                <ContentItem key={`list-end-${i}`} item={v} />
                                            ))}
                                        </>
                                    )}

                                    {/* Show list only if available (no videos) */}
                                    {list.length > 0 && videoList.length === 0 && (
                                        <>
                                            {list.map((v, i) => (
                                                <ContentItem key={i} item={v} />
                                            ))}
                                        </>
                                    )}

                                </div>

                                {(list.length > 0) && (
                                    <div className="pagination-row mt-5">
                                        <Pagination
                                            pageCount={listObj.pageCount}
                                            handlePageClick={handlePageClick}
                                            setPageLimit={setPageLimit}
                                            page={listObj.page - 1}
                                            limit={listObj.limit}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 tab-sidebar">
                        <div className="m-b-20" id="espotImg"></div>
                        <div className="newsletter m-b-20">
                            <div className="newsletter-title font-24 font-bold font-apercu">Newsletter</div>
                            <p className="m-b-15 text-black">Subscribe for online delivery</p>
                            <a className="bs5 btn btn-primary w135">Sign up now</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllContentTab;
